import Config from 'app/Config';
import purpleChevron from '../assets/images/purpleChevron.svg';
import {PORTALS_NAMES, ACTION_TITLES} from './constants';
import gaParams from 'app/utilities/analytics/constants';
import {gaEvent} from 'app/utilities/analytics/tracking';

export const getFullUrlOrDefault = (link, defaultLink='') => {
  return link?.value ? Config.epiBaseUrl + link.value : defaultLink;
};
export const getImageUrlOrDefault = (link, defaultLink='') => {
  return link?.value?.url ? Config.epiBaseUrl + link.value.url : defaultLink;
};
export const getTextOrDefault = (text, defaultText='') => {
  return text?.value ? text.value : defaultText;
};
export const getPortalsArr = (portals, contentData) => {
  const {monitoringPortalLink, businessInternetPortalLink} = contentData || {};

  const allPortals = {
    [PORTALS_NAMES.MONITOR]: {
      title: 'פורטל ניטור',
      linkText: 'לצפייה',
      link: monitoringPortalLink?.value,
      icon: purpleChevron,
    },
    [PORTALS_NAMES.BUSINESS_INTERNET]: {
      title: 'עסקי באינטרנט',
      linkText: 'לצפייה',
      link: businessInternetPortalLink?.value,
      icon: purpleChevron,
    },
  };

  if (!portals || portals.length === 0) {
    return [];
  }

  return portals.map((portalName) => allPortals[portalName]).filter((portal) => portal !== undefined);
};

export const isEmptyString = (value) => {
  return value.trim() === '';
};

export const getActionTitle = (actionName) => {
  return ACTION_TITLES[actionName] || null;
};

export const getActionPermission = (actionTitle, permissions, isServiceManager, allowDependingOnRent) => {
  const {allowedScActions, allowedBusinessReports, allowedCellular, allowedUploadOrgUsersList} = permissions;

  if (isServiceManager) return false;

  switch (actionTitle) {
    case ACTION_TITLES.LOADING_EMPLOYEES_DETAILS:
      return allowedUploadOrgUsersList;

    case ACTION_TITLES.UPDATE_PAYMENT_METHOD:
    case ACTION_TITLES.DEBT_PAYMENT:
    case ACTION_TITLES.WATCH_INVOICES:
      return allowedScActions;

    case ACTION_TITLES.UPLOAD_EMPLOYEES_DETAILS:
    case ACTION_TITLES.BUSINESS_REPORTS:
      return allowedBusinessReports;

    case ACTION_TITLES.CELLCOM_ABROAD:
    case ACTION_TITLES.SUBSCRIBER_DETAILS:
    case ACTION_TITLES.CHANGE_SIM:
    case ACTION_TITLES.DATA_USAGE:
    case ACTION_TITLES.SUSPEND_ACCOUNT:
    case ACTION_TITLES.DEVICE_REPAIR:
    case ACTION_TITLES.CCR_REPORT:
    case ACTION_TITLES.TRANSFER_BUSINESS_ACCOUNT:
    case ACTION_TITLES.RETRIEVE_QR_CODE:
    case ACTION_TITLES.OWNERSHIP_TRANSFER:
    case ACTION_TITLES.WORK_ORDER_SYSTEM:
    case ACTION_TITLES.DWH_SYSTEM:
    case ACTION_TITLES.ACTIVATE_NIUD:
    case ACTION_TITLES.CHECK_NIUD_STATUS:
      return allowedCellular;

    case ACTION_TITLES.LOCK_UNLOCK_NP:
      return allowDependingOnRent && allowedCellular;
      
    default:
      return false;
  }
};

  export const reportGA = (reportActionName) => {
    gaEvent(
      gaParams.BUSINESS_PORTAL_CLICK_ON_ACTION_BOX.category,
      gaParams.BUSINESS_PORTAL_CLICK_ON_ACTION_BOX.eventType,
      reportActionName,
    );
  }
